import { render, staticRenderFns } from "./generalSettings.vue?vue&type=template&id=262bab9d&scoped=true&"
import script from "./generalSettings.vue?vue&type=script&lang=js&"
export * from "./generalSettings.vue?vue&type=script&lang=js&"
import style0 from "./generalSettings.vue?vue&type=style&index=0&id=262bab9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262bab9d",
  null
  
)

export default component.exports